import { Button, Grid, IconButton, MenuItem, TextField, Tooltip } from "@material-ui/core";
import { EnumReportesTabs, EnumStatusConekta, EnumTipoPago } from "../../../../settings/enumConfig";
import { Fragment, useEffect } from "react";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import Administrativo from "./Administrativo";
import { Autocomplete } from "@material-ui/lab";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import Conekta from "./Conekta";
import { DatePicker } from "@material-ui/pickers";
import DetalleOrden from "./DetalleOrden";
import MeditocActions from "../../../utils/MeditocActions";
import MeditocBody from "../../../utils/MeditocBody";
import MeditocDateIcon from "../../../utils/MeditocDateIcon";
import MeditocHeader from "../../../utils/MeditocHeader";
import MeditocTab from "../../../utils/MeditocTab";
import MeditocTabs from "../../../utils/MeditocTabs";
import RefreshIcon from "@material-ui/icons/Refresh";
import { useCatalogo } from "../../../../context/CatalogoContext";
import { useLogin } from "../../../../context/LoginContext";
import { useReporteVenta } from "../../../../context/ReporteVentaContext";

export default function ReporteVentas() {
    const { usuarioPermisos } = useLogin();
    const { entCatalogos } = useCatalogo();
    const {
        reporteVenta,
        listaCupones,
        tabIndex,
        formFiltro,
        handleChangeTanIndex,
        handleChangeFormFiltroText,
        handleChangeFormFiltroDate,
        handleChangeFormFiltroCupon,
        handleClickFiltrarVentas,
        handleClickRefrescarDatos,
        handleClickDescargarReporte,
    } = useReporteVenta();

    const permisos = usuarioPermisos["5"].Submodulos["1"];

    const { txtFechaDe, txtFechaA, txtEstatus, txtOrigen, txtTipoPago, txtOrden, txtFolio, txtFolioEmpresa, txtCupon } =
        formFiltro;

    useEffect(() => {
        handleClickRefrescarDatos();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <MeditocHeader title={permisos.Nombre}>
                {permisos.Botones["1"] && ( //Descargar Reporte
                    <Tooltip title={permisos.Botones["1"].Nombre} arrow>
                        <IconButton onClick={handleClickDescargarReporte}>
                            <CloudDownloadIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["2"] && ( //Actualizar Reporte
                    <Tooltip title={permisos.Botones["2"].Nombre} arrow>
                        <IconButton onClick={handleClickRefrescarDatos}>
                            <RefreshIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
            </MeditocHeader>
            {reporteVenta && (
                <MeditocBody>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <MeditocActions title="Filtrar órdenes" />
                        </Grid>
                        <Grid item sm={4} xs={12}>
                            <DatePicker
                                name="txtFechaDe"
                                label={txtFechaDe.label}
                                value={txtFechaDe.value}
                                onChange={(date) => handleChangeFormFiltroDate(date, "txtFechaDe")}
                                InputProps={{ endAdornment: <MeditocDateIcon /> }}
                                inputVariant={inputVariant}
                                format="dd/MM/yyyy"
                                color={inputColor}
                                variant="inline"
                                fullWidth
                                autoOk={true}
                            />
                        </Grid>
                        <Grid item sm={4} xs={12}>
                            <DatePicker
                                name="txtFechaA"
                                label={txtFechaA.label}
                                value={txtFechaA.value}
                                onChange={(date) => handleChangeFormFiltroDate(date, "txtFechaA")}
                                InputProps={{ endAdornment: <MeditocDateIcon /> }}
                                inputVariant={inputVariant}
                                format="dd/MM/yyyy"
                                color={inputColor}
                                variant="inline"
                                fullWidth
                                autoOk={true}
                            />
                        </Grid>
                        <Grid item sm={4} xs={12}>
                            <TextField
                                name="txtOrigen"
                                label={txtOrigen.label}
                                value={txtOrigen.value}
                                onChange={handleChangeFormFiltroText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                select
                            >
                                <MenuItem value="">Todos</MenuItem>
                                {entCatalogos.catOrigen.map((origen) => (
                                    <MenuItem key={origen.fiId} value={origen.fiId}>
                                        {origen.fsDescripcion}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item sm={4} xs={12}>
                            <TextField
                                name="txtEstatus"
                                label={txtEstatus.label}
                                value={txtEstatus.value}
                                onChange={handleChangeFormFiltroText}
                                variant={inputVariant}
                                color={inputColor}
                                disabled={tabIndex === EnumReportesTabs.Administrativo}
                                fullWidth
                                select
                            >
                                <MenuItem value="">Todos</MenuItem>
                                <MenuItem value={EnumStatusConekta.Paid}>{EnumStatusConekta.Paid}</MenuItem>
                                <MenuItem value={EnumStatusConekta.Declined}>{EnumStatusConekta.Declined}</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item sm={4} xs={12}>
                            <TextField
                                name="txtTipoPago"
                                label={txtTipoPago.label}
                                value={txtTipoPago.value}
                                onChange={handleChangeFormFiltroText}
                                variant={inputVariant}
                                color={inputColor}
                                disabled={tabIndex === EnumReportesTabs.Administrativo}
                                fullWidth
                                select
                            >
                                <MenuItem value="">Todos</MenuItem>
                                <MenuItem value={EnumTipoPago.Credit}>Crédito</MenuItem>
                                <MenuItem value={EnumTipoPago.Debit}>Débito</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item sm={4} xs={12}>
                            <Autocomplete
                                id="txtCupon"
                                value={txtCupon.value}
                                options={listaCupones}
                                noOptionsText="Sin coincidencias"
                                onChange={handleChangeFormFiltroCupon}
                                disabled={tabIndex === EnumReportesTabs.Administrativo}
                                renderInput={(props) => (
                                    <TextField
                                        {...props}
                                        name="txtCupon"
                                        label={txtCupon.label}
                                        variant={inputVariant}
                                        color={inputColor}
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item sm={4} xs={12}>
                            <TextField
                                name="txtOrden"
                                label={txtOrden.label}
                                value={txtOrden.value}
                                onChange={handleChangeFormFiltroText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                            />
                        </Grid>
                        <Grid item sm={4} xs={12}>
                            <TextField
                                name="txtFolioEmpresa"
                                label={txtFolioEmpresa.label}
                                value={txtFolioEmpresa.value}
                                onChange={handleChangeFormFiltroText}
                                variant={inputVariant}
                                color={inputColor}
                                /*

                                
                                disabled={tabIndex === EnumReportesTabs.Conekta}


                                */
                                fullWidth
                            />
                        </Grid>
                        <Grid item sm={4} xs={12}>
                            <TextField
                                name="txtFolio"
                                label={txtFolio.label}
                                value={txtFolio.value}
                                onChange={handleChangeFormFiltroText}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} className="right">
                            <Button
                                variant="contained"
                                style={{ color: "#555", marginRight: 15 }}
                                onClick={handleClickRefrescarDatos}
                            >
                                Limpiar filtro
                            </Button>
                            <Button variant="contained" color="primary" onClick={handleClickFiltrarVentas}>
                                Filtrar ventas
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <MeditocTabs
                                index={tabIndex}
                                setIndex={handleChangeTanIndex}
                                tabs={["VENTAS CONEKTA", "VENTAS ADMINISTRATIVAS"]}
                            >
                                <MeditocTab id={0} index={tabIndex}>
                                    <Conekta />
                                </MeditocTab>
                                <MeditocTab id={1} index={tabIndex}>
                                    <Administrativo />
                                </MeditocTab>
                            </MeditocTabs>
                        </Grid>
                    </Grid>
                </MeditocBody>
            )}
            <DetalleOrden />
        </Fragment>
    );
}
